export default {
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ['[TeamID]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Group Standing Team]'],
          qSortCriterias: [
            {
              qSortByExpression: -1,
              qExpression: {
                qv: '=Sum(Num([Group Standing Goals For]) - Num([Group Standing Goals Against]))',
              },
            }],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Group Standing Group]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Group Standing Points]'],
          qSortCriterias: [
            {
              qSortByNumeric: -1,
            },
          ],
        },
        qAttributeExpressions: [
          {
            qExpression: '=Sum(Num([Group Standing Goals For]) - Num([Group Standing Goals Against]))',
          },
        ],
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Group Standing Goals For]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Group Standing Goals Against]'],
        },
        qNullSuppression: false,
      },
    ],
    qInitialDataFetch: [{ qWidth: 6, qHeight: 1500 }],
    qInterColumnSortOrder: [3, 4, 2, 1, 5, 0],
  },
};
